import { render, staticRenderFns } from "./AcceptTos.vue?vue&type=template&id=984f62b0&"
import script from "./AcceptTos.vue?vue&type=script&lang=ts&"
export * from "./AcceptTos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports